import { render, staticRenderFns } from "./AppointmentDetailsSkeleton.vue?vue&type=template&id=32902c5c&scoped=true"
import script from "./AppointmentDetailsSkeleton.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetailsSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32902c5c",
  null
  
)

export default component.exports